import { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { APP_VERSION } from './constants';
import FullScreenMessage from './elements/FullScreenMessage';
import { getStatus } from './utils/getStatus';

const POLL_INTERVAL = 60 * 5;

const MessageContent = () => (
  <div>
    Es steht eine neue Version der Website zur Verfügung! <a href='.'>Hier</a>{' '}
    klicken, um die Seite neu zu laden.
  </div>
);

const VersionChecker = ({ children }) => {
  const [appNeedsUpdate, setAppNeedsUpdate] = useState(false);
  const { addToast, removeAllToasts } = useToasts();

  useEffect(() => {
    async function checkStatus() {
      const statusResult = await getStatus();
      const { recommendedWebVer, minWebVer } = statusResult;
      if (recommendedWebVer && minWebVer) {
        // console.log({ minWebVer, recommendedWebVer, APP_VERSION });
        if (APP_VERSION < recommendedWebVer && APP_VERSION >= minWebVer) {
          removeAllToasts();
          addToast(<MessageContent />, {
            appearance: 'warning',
          });
        }
        if (APP_VERSION < minWebVer) {
          setAppNeedsUpdate(true);
        }
        // setStatus(prevStatus => statusResult.status);
        // setMaintenanceMessage(statusResult.maintenanceMessage);
      }
    }

    checkStatus();
    const interval = setInterval(async () => {
      checkStatus();
    }, 1000 * POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [addToast, removeAllToasts]);

  if (appNeedsUpdate) {
    return <FullScreenMessage message={<MessageContent />} />;
  }

  return children;
};

export default VersionChecker;
